import { render, staticRenderFns } from "./stencilDetails.vue?vue&type=template&id=8db03292&scoped=true&"
import script from "./stencilDetails.vue?vue&type=script&lang=js&"
export * from "./stencilDetails.vue?vue&type=script&lang=js&"
import style0 from "./stencilDetails.vue?vue&type=style&index=0&id=8db03292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db03292",
  null
  
)

export default component.exports